import type { ReportCell, ReportColumn, ReportRow } from "../../../../api/types/widgetTypes";

export interface TabularReportCellValueData {
  column: Pick<ReportColumn, "id" | "title" | "dataType">;
  cell: ReportCell | undefined;
}

export const getCellValuesForReportRow = (
  row: ReportRow,
  columns: Pick<ReportColumn, "id" | "title" | "dataType">[]
): TabularReportCellValueData[] => {
  return columns.map((column) => ({ column, cell: row.cells[column.id] }));
};
